import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, renderSlot as _renderSlot, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = ["disabled", "type"];
const _hoisted_2 = { key: 1 };
import { computed } from 'vue';
import SvgIcon from '@/components/SvgIcon.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'PillButton',
    props: {
        kind: { type: String, default: 'primary' },
        disabled: { type: Boolean, default: false },
        type: {
            type: String,
            default: 'button'
        },
        size: { type: String, default: 'md' },
        floating: { type: Boolean, default: false },
        pressed: { type: Boolean, default: false },
        loading: { type: Boolean, default: false }
    },
    emits: ['click'],
    setup(__props, { emit }) {
        const props = __props;
        const disabledOrLoading = computed(() => props.disabled || props.loading);
        const enabled = computed(() => !disabledOrLoading.value);
        const large = computed(() => props.size === 'lg');
        const medium = computed(() => props.size === 'md');
        const small = computed(() => props.size === 'sm');
        const xl = computed(() => props.size === 'xl');
        function handleClick() {
            emit('click');
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["flex items-center justify-center rounded-full whitespace-nowrap", {
                        'text-white': __props.kind === 'primary' && _unref(enabled),
                        'border border-gray-900 dark:border-primary-600': __props.kind === 'primary' && _unref(enabled) && !__props.floating,
                        'bg-gray-900 hover:bg-primary-900 dark:bg-primary-600 dark-hover:bg-primary-700': __props.kind === 'primary' && _unref(enabled),
                        'text-gray-900 dark:border dark:border-gray-300': __props.kind === 'secondary' && _unref(enabled),
                        'border border-gray-900': __props.kind === 'secondary' && _unref(enabled) && !__props.floating,
                        'dark:text-gray-300 bg-white hover:bg-primary-100 dark:bg-gray-700 dark-hover:bg-gray-900': __props.kind === 'secondary' && _unref(enabled) && !__props.pressed,
                        'dark:text-gray-700 bg-primary-200 hover:bg-primary-300 dark:bg-gray-300 border-primary-300 dark-hover:bg-gray-200 dark:border-gray-300': __props.kind === 'secondary' && _unref(enabled) && __props.pressed,
                        'dark:text-gray-500 bg-gray-200 dark:bg-gray-600 border border-gray-200 dark:border-gray-600': _unref(disabledOrLoading),
                        'border border-gray-300 dark:border-transparent shadow-200': __props.floating,
                        'w-full': _unref(large) || _unref(xl),
                        'w-full sm:w-auto': _unref(medium)
                    }])
            }, [
                _createElementVNode("button", {
                    disabled: _unref(disabledOrLoading),
                    type: __props.type,
                    class: _normalizeClass({
                        'opacity-50 cursor-not-allowed': _unref(disabledOrLoading),
                        'text-xs h-6 sm:h-4 px-3 font-medium': _unref(small),
                        'text-sm w-full h-10 sm:h-8 px-6 font-bold': _unref(medium),
                        'text-lg sm:text-sm w-full h-10 sm:h-8 px-6 font-bold': _unref(large),
                        'text-2xl w-full h-16 px-6 font-bold': _unref(xl)
                    }),
                    onClick: handleClick
                }, [
                    (__props.loading)
                        ? (_openBlock(), _createBlock(SvgIcon, {
                            key: 0,
                            name: "ellipsis",
                            class: "w-full h-8 opacity-50"
                        }))
                        : (_openBlock(), _createElementBlock("span", _hoisted_2, [
                            _renderSlot(_ctx.$slots, "default")
                        ]))
                ], 10, _hoisted_1)
            ], 2));
        };
    }
});
